import React from 'react';
import Button from '@mui/material/Button'
function ListSingleProject() {
  return <div>
      <Button>List single project</Button>
  </div>;
}

export default ListSingleProject;
